module.exports = __webpack_public_path__ + "static/media/superspade.c31797bf.jpeg";